import { Trans } from '@lingui/react'
import { arrayOf, bool, number, shape } from 'prop-types'
import { Component } from 'react'

import Button from 'views/components/atoms/Button'
import IconButtonArrowRight from 'views/components/atoms/Icon/IconButtonArrowRight'
import { MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER } from 'views/consts'
import ProductType from 'views/utils/propTypes/api/Product_v1'

import MoreProductsContainerSlider from './MoreProductsContainerSlider'

class MoreProductsContainer extends Component {
  static propTypes = {
    products: arrayOf(shape(ProductType)).isRequired,
    noSlider: bool,
    showBuyButton: bool,
    wid: number,
  }

  constructor(props) {
    super(props)

    const { products, noSlider, showBuyButton, wid } = props
    const showMore = products.length > MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER

    this.state = {
      currentProducts: showMore
        ? products.slice(0, MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
        : products,
      restProducts: showMore
        ? products.slice(MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
        : null,
      noSlider,
      showBuyButton,
      wid,
    }
  }

  showMore = event => {
    const { currentProducts, restProducts, noSlider, showBuyButton, wid } =
      this.state
    const showMore = restProducts.length > MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER

    this.setState({
      currentProducts: currentProducts.concat(
        restProducts.slice(0, MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
      ),
      restProducts: showMore
        ? restProducts.slice(MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
        : null,
      noSlider,
      showBuyButton,
      wid,
    })

    event.target.blur()
  }

  render() {
    const { currentProducts, restProducts, noSlider, showBuyButton, wid } =
      this.state

    return (
      <>
        <MoreProductsContainerSlider
          products={currentProducts}
          noSlider={noSlider}
          showBuyButton={showBuyButton}
          wid={wid}
        />

        {Boolean(restProducts?.length) && (
          <div className="o-SliderHorizontal__show-more u-text-align--center u-padding--top">
            <Button
              reverse
              inlineDesktopOnly
              onClick={this.showMore}
              name="show-more-products-button"
            >
              <Trans id="general.label.loadMoreProducts" />
              <IconButtonArrowRight className="a-icon-button-arrow-right" />
            </Button>
          </div>
        )}
      </>
    )
  }
}

export default MoreProductsContainer
